import {IPortMonitorLocation} from './IPortMonitor';

export const getLocationCityName = (city?: IPortMonitorLocation['city'] | null): string => {
    if (!city) {
        return '';
    }

    return typeof city === 'string' ? city : city.name;
};
